import { http, HttpResponse } from 'msw';
import { mockCheckoutWaivers } from 'domains/ConsolidatedCheckout/__dev__/mockValues_Checkout';

export enum CheckoutEndpoint {
  AddDiscountCodes = '*/api/member-portal/*/checkout/billingSummary*',
  GetWaivers = '*/api/sites/*/waivers',
  ProcessCart = '*/api/cart/sites/*/users/*/cart/process',
}

export const checkoutHandlers = [
  // Checkout waivers
  http.get(CheckoutEndpoint.GetWaivers, () => {
    return HttpResponse.json(mockCheckoutWaivers, { status: 200 });
  }),
  // ProcessCart
  http.post(CheckoutEndpoint.ProcessCart, () => {
    return new HttpResponse(null, { status: 204 });
  }),
  // Add Discount Codes
  http.post(CheckoutEndpoint.AddDiscountCodes, () => {
    return new HttpResponse(null, { status: 204 });
  }),
];
